module.exports = __webpack_public_path__ + "img/avatar5.012b9f6d.jpg";